<template>
  <div>
    <div class="Minister-top information uploadPictures">
      <div class="Minister-top-top Ministerbackground">
        <div class="Minister-top-left Minister-top-color">产品图片</div>
      </div>
      <div class="productimgs">
        <div v-if="system == 5 && !isChakan && imgListSelect.length > 0">
          <el-button
              style="margin-bottom: 6px;margin-left: 12rpx"
              type="primary"
              @click="setAllWhite"
          >
            图片白底
          </el-button>
          <el-button
              style="margin-bottom: 6px;margin-left: 12rpx"
              type="primary"
              @click="setAllFenbianlv"
          >
            修改分辨率
          </el-button>
        </div>
        <div class="fluid container">
          <draggable
              class="list-group"
              tag="ul"
              @start="isDragging = true"
              @end="isDragging = false"
              :list="imgListSelect"
              handle=".list-group-item"
          >
            <li
                class="list-group-item"
                v-for="(element, index) in imgListSelect"
                :key="index + 'img'"
            >
              <div class="mask" v-if="system == 5 && !isChakan">
                <i
                    class="custom-icon el-icon-zoom-in"
                    @click="handlePictureCardPreview(element)"
                ></i>
                <i
                    class="custom-icon el-icon-delete"
                    @click="handleRemoveSelect(index)"
                ></i>
                <el-dropdown @command="handleCommand">
  <span class="el-dropdown-link">
     <i
         class="custom-icon el-icon-edit"
         @click="handleEdit(index)"
     ></i>
  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="beforeHandleCommand('baidi',index)">图片白底</el-dropdown-item>
                    <el-dropdown-item :command="beforeHandleCommand('fenbianlv',index)">修改分辨率</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
              <div class="badge">
                <img :src="element" alt/>
              </div>
            </li>
            <li
                v-if="system == 5 && !isChakan"
                @click="selectImg"
                class="avatar-uploader"
                slot="footer"
            >
              <i data-v-c660ac10 class="el-icon-plus"></i>
            </li>
          </draggable>
        </div>
        <!-- <p style="margin-top: 10px">
          图片可批量上传，只支持
          <span style="color: red; font-weight: bold">JPG/TIFF/JPEG</span>
          格式图片，首选
          <span style="color: red; font-weight: bold">JPEG</span>
          格式， 图片的最长边不应低于
          <span style="color: red; font-weight: bold">1600</span>
          像素，最长边不得超过
          <span style="color: red; font-weight: bold">10,000</span>
          像素，不能包含徽标或水印。商品必须是填满
          <span style="color: red; font-weight: bold">85%</span>
          的图片,图片详细标准请参阅Amazon平台要求。
        </p> -->
      </div>
    </div>
    <el-dialog
        ref="box"
        title="选择图片"
        :visible.sync="dialogVisibleSelect"
        :modal-append-to-body="false"
        append-to-body
        width="1200px"
    >
      <draggable
          class="list-group"
          tag="ul"
          @start="isDragging = true"
          @end="isDragging = false"
          :list="imgListUpdate"
          handle=".list-group-item"
      >
        <el-upload
            class="upload-demo"
            ref="dialogSelect"
            accept="image/jpeg, image/tiff"
            drag
            multiple
            :action="uploadAction || action"
            :before-upload="beforeUpload"
            :on-change="onChange"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-error="handleError"
            :http-request="customRequest"
            :headers="customHeaders"
            :file-list="imgListUpdate"
            :show-file-list="showFileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>选择图片</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传JPG/PNG文件，且不超过2M
          </div>
        </el-upload>
        <div style="margin-top: 10px">
          <div style="display: flex; width: 100%; flex-wrap: wrap">
            <img
                v-for="(item, index) in lianjieUrlList"
                :key="index"
                :src="item"
                class="prduct_img"
                alt
            />
          </div>
          <el-button
              style="margin-top: 6px"
              type="primary"
              @click="lianjiedaoru"
          >
            链接导入
          </el-button>
        </div>
      </draggable>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSelect = false">取 消</el-button>
        <el-button type="primary" @click="sureImg">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleSee" width="500px" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt/>
    </el-dialog>
    <el-dialog
        ref="box2"
        :visible.sync="lianjieVisibleSee"
        width="900px"
        title="图片链接导入"
        append-to-body
    >
      <el-input
          type="textarea"
          placeholder="不同图片链接请用英文逗号隔开"
          v-model="lianjieUrl"
          maxlength="5000"
          show-word-limit
          :disabled="system < 5"
      ></el-input>
      <div style="margin-top: 10px; color: red">
        不同图片链接请用英文逗号隔开
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lianjieVisibleSee = false">取 消</el-button>
        <el-button type="primary" @click="sureLianjie">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        ref="box3"
        :visible.sync="fenbianlvVisible"
        width="900px"
        :title="editPictureTitle"
        append-to-body
    >
      <div style="display: flex">
        <el-checkbox :disabled="buttonLoadding" v-if="!isClickItem" v-model="isAllSelect" @change="changeAllSelect" style="margin-top: 8px;margin-bottom: 12px">全选</el-checkbox>
        <el-form :inline="true" label-width="60px" :model="pictureForm" v-if="comName == 'fenbianlv'">
          <el-form-item label="分辨率:">
            <el-select v-model="pictureForm.fenbianlType" placeholder="请选择" @change="changeFenbianType" :disabled="buttonLoadding">
              <el-option label="800*800px" :value="800"></el-option>
              <el-option label="1000*1000px" :value="1000"></el-option>
              <el-option label="1200*1200px" :value="1200"></el-option>
              <el-option label="1500*1500px" :value="1500"></el-option>
              <el-option label="自定义" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宽:" :disabled="buttonLoadding"
                        v-if="pictureForm.fenbianlType == 4">
            <el-input
                placeholder="请输入图片宽度"
                v-model="pictureForm.width"
                style="margin-top: 3px"
            >
              <template slot="append">px</template>
            </el-input>
          </el-form-item>
          <el-form-item label="高:" :disabled="buttonLoadding"
                        v-if="pictureForm.fenbianlType == 4">
            <el-input
                placeholder="请输入图片高度"
                v-model="pictureForm.height"
                style="margin-top: 3px"
            >
              <template slot="append">px</template>
            </el-input>
          </el-form-item>

        </el-form>
      </div>
      <ul class="select-img" v-if="fenbianlvPrctureList.length">
        <li
            class="option"
            v-for="(item, index) in fenbianlvPrctureList"
            :key="index"
            @click="clickItemChecked(item)">
          <div
              class="img-mask"
              v-if="item.isChecked">
            <i class="el-icon-upload-success el-true-check">
            </i>
          </div>
          <img :src="item.url" alt/>
        </li>
      </ul>

      <span slot="footer" class="dialog-footer">
        <el-button :loading="buttonLoadding" @click="fenbianlvVisible = false">取 消</el-button>
        <el-button :loading="buttonLoadding" type="primary" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {Baseurl, ajaxPost} from "@/api/api/api";
import Axios from "axios";

export default {
  components: {
    draggable,
  },
  props: {
    pageType: {
      type: String,
      default: () => "",
    },
    uploadAction: {
      type: String,
      default: "",
    },
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttonLoadding:false,
      pictureForm: {
        fenbianlType: 800,
        width: 800,
        height: 800
      },
      //保存数组的长度
      saveListLength:0,
      //是否全选
      isAllSelect: false,
      //分辨率\白底 弹窗标题
      editPictureTitle: '修改分辨率',
      //修改分辨率弹窗控制
      fenbianlvVisible: false,
      //分辨率图片数组
      fenbianlvPrctureList: [],
      //用于批量修改图片尺寸时,获取修改前图片的下标
      indexImgList:[],
      //点击修改的图片下标
      selectEditPictrueIndex: 0,
      //是点击图片上的按钮,还是点击的顶部的编辑按钮 true 图片 false 顶部
      isClickItem: true,
      //点击的是哪个菜单类型 baidi:白底   fenbianl:分辨率修改
      comName: 'baidi',
      //文件上传前获取文件的uid
      beforeUploadFileUid: '',
      lianjieUrl: "",
      lianjieUrlList: [],
      lianjieVisibleSee: false,
      action: Baseurl + "imageController/uploadImage",
      dialogVisibleSelect: false,
      dialogVisibleSee: false,
      dialogImageUrl: "",
      imgList: "",
      imgListUpdate: [],
      //页面展示的图片
      imgListSelect: [],
      isDragging: false,
      customHeaders: {token: localStorage.getItem("token")},
      updateImageList: [],
      arr: [],
      sellerId: undefined,
      showFileList: false,
      str: null
    };
  },
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
  },
  methods: {
// 通过Fetch API获取Blob对象
    getBlobFromURL(url) {
      return fetch(url)
          .then(response => {
            if (response.ok) {
              return response.blob();
            } else {
              throw new Error(response.statusText);
            }
          });
    },
    setSellerId(sellerId) {
      this.sellerId = sellerId;
    },
    selectImg() {
      if (!this.sellerId) {
        this.$message.warning("请先选择店铺,再上传产品图片!");
        return;
      }
      this.dialogVisibleSelect = true;
    },
    addImgList(imgArr) {
      this.imgListSelect = imgArr;
      this.$emit("ImgList", this.imgListSelect);
    },
    // 父组件添加图片相应
    addImg(file) {
      this.imgListSelect.push(file);
      this.$emit("ImgList", this.imgListSelect);
    },
    sureImg() {
      if (this.imgListUpdate.length === 0 && this.lianjieUrlList.length === 0) {
        this.$message.success("请先选择图片...");
        return;
      }
      // this.submitUpload();
      if (!this.showFileList) {
        this.$message.success("图片正在上传...");
        return;
      }
      if (this.arr == true || this.showFileList) {
        // this.$message.success('上传成功')
        let ss = this.imgListUpdate.map((item) => item.url);
        this.imgListSelect = [
          ...this.imgListSelect,
          ...ss,
          ...this.lianjieUrlList,
        ];
        this.imgListUpdate = [];
        this.lianjieUrlList = [];
        // this.$refs.dialogSelect.clearFiles();
        this.dialogVisibleSelect = false;

        this.$emit("ImgList", this.imgListSelect);
      }
    },
    submitUpload() {
      // this.$refs.dialogSelect.submit();
    },

    beforeUpload(file) {
      this.beforeUploadFileUid = file.uid
      return true;
    },
    onChange(file, fileList) {
      this.imgList = fileList;
    },
    async customRequest({file}) {
      this.showFileList = false;
      const loading = this.$loading({
        target: this.$refs.box.$el,
        text: "正在上传图片...",
        background: "rgba(218,218,238,0.2)",
      });
      const url = await this.upload(file);
      if (url) {
        this.imgListUpdate.push({name: file.fileName, url});
        this.showFileList = true;
        loading.close();
      } else {
        loading.close();
      }
    },
    upload(file) {
      const API = Baseurl + "allegroImage/uploadImage";
      const formData = new FormData();
      formData.append("file", file);
      formData.append("sellerId", this.sellerId);
      return Axios({
        url: API,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
          .then(async (res) => {
            if (res.data.code === 200 && res.data.data) {
              return res.data.data;
            } else {
              //返回null的话,需要删除组件本身的文件存留
              if (res.data.code === 200 && !res.data.data) {
                let _this = this
                //获取失败文件的下标
                let idx = this.$refs.dialogSelect.uploadFiles.findIndex(item => item.uid === _this.beforeUploadFileUid)
                this.$refs.dialogSelect.uploadFiles.splice(idx, 1)
                this.$message.error('上传失败,请重新上传该图片!')
              }
              return false;
            }
          })
          .catch(() => {
            return false;
          });
    },
    async handSuccess(res, file, fileList) {
      this.arr = fileList.every((item) => item.response.code === 200);
      if (this.arr == true) {
        const imgList = [];
        for (let index = 0; index < fileList?.length; index++) {
          const {code, data} = fileList[index].response;
          if (code === 200) {
            const imgUrl = await await this.changeImgUrl(data);
            const f = fileList[index];
            f.response.data = imgUrl;

            imgList.push({
              name: "1.jpg",
              url: imgUrl,
            });
          }
        }
        this.imgListUpdate = imgList;
        this.$message.success("上传成功");
      } else {
        this.$message.error(res.data);
      }
    },
    changeImgUrl(url) {
      const sendData = {
        sellerId: this.sellerId,
        url,
      };
      const API = Baseurl + "allegroImage/uploadOfferImage";
      return ajaxPost(API, sendData)
          .then((res) => {
            const {code, data} = res.data;
            if (code === 200) {
              return data;
            } else {
              return undefined;
            }
          })
          .catch(() => {
            return undefined;
          });
    },
    uploading(msg) {
      this.$message.success(msg);
    },
    handleError(err, file, fileList) {
      this.$message.error(err);
    },
    handlePictureCardPreview(file) {
      let imageUrl = "";
      if (Object.prototype.toString.call(file) === "[object Object]") {
        imageUrl = file.response.data;
      } else {
        imageUrl = file;
      }
      this.dialogImageUrl = imageUrl;
      this.dialogVisibleSee = true;
    },
    handleRemove(file, fileList) {
      this.imgListUpdate = fileList;
    },
    handleRemoveSelect(index) {
      this.imgListSelect.splice(index, 1);
      this.$emit("ImgList", this.imgListSelect);
    },
    //点击编辑图片
    handleEdit(index) {

    },
    downloadImgs() {
      this.$emit("downloadImgs");
    },
    lianjiedaoru() {
      this.lianjieUrl = "";
      let url = "";
      if (this.lianjieUrlList.length > 0) {
        for (let i = 0; i < this.lianjieUrlList.length; i++) {
          url = url + this.lianjieUrlList[i] + ",";
        }
      }
      this.lianjieUrl = url.slice(0, -1);
      this.lianjieVisibleSee = true;
    },
    async sureLianjie() {
      if (this.lianjieUrl) {
        const loading = this.$loading({
          target: this.$refs.box2.$el,
          text: "正在上传图片...",
          background: "rgba(218,218,238,0.2)",
        });
        const imgList = [];
        const urlList = this.lianjieUrl.split(",");
        for (let index = 0; index < urlList?.length; index++) {
          const url = urlList[index];
          const imgUrl = await this.changeImgUrl(url);
          imgList.push(imgUrl);
        }
        this.lianjieUrlList = urlList;
        this.arr = true;
        loading.close();
        this.lianjieVisibleSee = false;
        this.showFileList = true;
      } else {
        this.lianjieVisibleSee = false;
      }
    },
    //修改图片白底
    SetPicTureWhite(selectImg, index,saveIndex) {
      let params = {
        "sellerId": this.sellerId,
        "oldImgUrl": selectImg,
        "companyId": this.str.company_id,
        "rid": this.str.rid
      }
      console.log(params)
      const url =
          Baseurl + "allegroImage/handleImageWhite";
      ajaxPost(url, params).then(async (res) => {
        if (res.data.code === 200 && res.data.data) {
          if (index == -1){
            this.imgListSelect[this.selectEditPictrueIndex] = res.data.data
            this.$emit("ImgList", this.imgListSelect);
            this.$message.success('修改白底成功!')
            this.buttonLoadding = false
            this.fenbianlvVisible = false
          } else {
            //这个index 是保存数组的下标, 需要从indexImgList中找到真真的下标
            this.imgListSelect[index] = res.data.data
            this.$emit("ImgList", this.imgListSelect);
            //最后一个
            if (saveIndex == this.saveListLength - 1){
              this.$message.success('修改白底成功!')
              this.fenbianlvVisible = false
              this.buttonLoadding = false
            }
          }
        } else {
          this.buttonLoadding = false
          this.$message.error('修改白底错误,请重新转换!')
        }
      }).catch(() => {
        this.buttonLoadding = false
        this.$message.error('修改白底错误,请重新转换!')
      });
    },
    //修改图片白底 传文件流
    SetPicTureWhiteNew(selectImg, index,saveIndex) {
      // 获取Blob对象
      this.getBlobFromURL(selectImg).then(blob => {
        // 将Blob转换为File对象
        const file = new File([blob], 'image.jpg', { type: blob.type });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("sellerId", this.sellerId);
        formData.append("companyId", this.str.company_id);
        formData.append("rid", this.str.rid);
        let newAPI = Baseurl + "allegroImage/handleImageWhiteNew"
        Axios({
          url: newAPI,
          method: "post",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(async (res) => {
              if (res.data.code === 200 && res.data.data) {
                if (index == -1){
                  this.imgListSelect[this.selectEditPictrueIndex] = res.data.data
                  this.$emit("ImgList", this.imgListSelect);
                  this.$message.success('修改白底成功!')
                  this.buttonLoadding = false
                  this.fenbianlvVisible = false
                } else {
                  //这个index 是保存数组的下标, 需要从indexImgList中找到真真的下标
                  this.imgListSelect[index] = res.data.data
                  this.$emit("ImgList", this.imgListSelect);
                  //最后一个
                  if (saveIndex == this.saveListLength - 1){
                    this.$message.success('修改白底成功!')
                    this.fenbianlvVisible = false
                    this.buttonLoadding = false
                  }
                }
              } else {
                this.buttonLoadding = false
                this.$message.error('修改白底错误,请重新转换!')
              }
            })
            .catch(() => {
              this.buttonLoadding = false
              this.$message.error('修改白底错误,请重新转换!')
              return false;
            });
      }).catch(error => {
        this.buttonLoadding = false
        this.$message.error('修改尺寸错误,请重新修改!')
        console.error('Error:', error);
      });
    },
    //修改图片分辨率
    SetPicTurePx(selectImg, index,saveIndex) {
      let params = {
        "sellerId": this.sellerId,
        "oldImgUrl": selectImg,
        "width": this.pictureForm.width,
        "height": this.pictureForm.height
      }
      const url =
          Baseurl + "allegroImage/updateImageSize";
      ajaxPost(url, params).then((res) => {
        if (res.data.code === 200 && res.data.data) {
          if (index == -1){
            this.imgListSelect[this.selectEditPictrueIndex] = res.data.data
            this.$emit("ImgList", this.imgListSelect);
            this.$message.success('修改尺寸成功!')
            this.buttonLoadding = false
            this.fenbianlvVisible = false
          } else {
            //这个index 是保存数组的下标, 需要从indexImgList中找到真真的下标
            this.imgListSelect[index] = res.data.data
            this.$emit("ImgList", this.imgListSelect);
            //最后一个
            if (saveIndex == this.saveListLength - 1){
              this.$message.success('修改尺寸成功!')
              this.fenbianlvVisible = false
              this.buttonLoadding = false
            }
          }
        } else {
          this.buttonLoadding = false
          this.$message.error('修改尺寸错误,请重新修改!')
        }
      }).catch(() => {
        this.buttonLoadding = false
        this.$message.error('修改尺寸错误,请重新修改!')
      });
    },
    //修改图片分辨率 传文件流
    SetPicTurePxNew(selectImg, index,saveIndex){
      // 获取Blob对象
      this.getBlobFromURL(selectImg).then(blob => {
        // 将Blob转换为File对象
        const file = new File([blob], 'image.jpg', { type: blob.type });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("sellerId", this.sellerId);
        formData.append("width", this.pictureForm.width);
        formData.append("height", this.pictureForm.height);
        let newAPI = Baseurl + "allegroImage/updateImageSizeNew"

        Axios({
          url: newAPI,
          method: "post",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
            .then(async (res) => {
              if (res.data.code === 200 && res.data.data) {
                if (index == -1){
                  this.imgListSelect[this.selectEditPictrueIndex] = res.data.data
                  this.$emit("ImgList", this.imgListSelect);
                  this.$message.success('修改尺寸成功!')
                  this.buttonLoadding = false
                  this.fenbianlvVisible = false
                } else {
                  //这个index 是保存数组的下标, 需要从indexImgList中找到真真的下标
                  this.imgListSelect[index] = res.data.data
                  this.$emit("ImgList", this.imgListSelect);
                  //最后一个
                  if (saveIndex == this.saveListLength - 1){
                    this.$message.success('修改尺寸成功!')
                    this.fenbianlvVisible = false
                    this.buttonLoadding = false
                  }
                }
              } else {
                this.buttonLoadding = false
                this.$message.error('修改尺寸错误,请重新修改!')
              }
            })
            .catch(() => {
              this.buttonLoadding = false
              this.$message.error('修改尺寸错误,请重新修改!')
              return false;
            });
      }).catch(error => {
        this.buttonLoadding = false
        this.$message.error('修改尺寸错误,请重新修改!')
        console.error('Error:', error);
      });
    },
    handleCommand(comObj) {
      this.selectEditPictrueIndex = comObj.index
      this.isClickItem = true
      this.comName = comObj.comName
      this.fenbianlvPrctureList = [{
        url: this.imgListSelect[comObj.index]
      }]
      this.fenbianlvVisible = true
      this.buttonLoadding = false
      this.editPictureTitle = (comObj.comName === 'baidi' ? '图片白底' : '修改分辨率')
      this.pictureForm = {
        fenbianlType: 800,
        width: 800,
        height: 800
      }
    },
    beforeHandleCommand(com, index) {
      return {
        comName: com,
        index: index
      }
    },
    //修改分辨率弹窗确认
    handleSave() {
      this.indexImgList = []
      let saveList = []
      if (this.isClickItem){
        saveList = this.fenbianlvPrctureList
      } else {
        saveList = this.fenbianlvPrctureList.filter(item =>{
          return item.isChecked
        })
      }
      this.saveListLength = saveList.length
      if (saveList.length == 0){
        this.$message.error('请选择图片后再进行操作!')
        return
      }
      saveList.forEach((item,index) =>{
        let oldIndex = this.imgListSelect.findIndex((findItem,findIndex) => {
          return findItem == item.url
        })
        this.indexImgList.push(oldIndex)
      })
      this.buttonLoadding = true
      //单个点击
      if (this.isClickItem){
        //白底修改
        if (this.comName == 'baidi'){
          this.SetPicTureWhiteNew(saveList[0].url,-1)
          //分辨率修改
        } else {
          this.SetPicTurePxNew(saveList[0].url,-1)
        }
      } else {
        saveList.forEach((item,itemIndex) =>{
          let oldIndex = this.indexImgList[itemIndex] //白底修改
          if (this.comName == 'baidi'){
            this.SetPicTureWhiteNew(item.url,oldIndex,itemIndex)
            //分辨率修改
          } else {
            this.SetPicTurePxNew(item.url,oldIndex,itemIndex)
          }
        })
      }
    },
    //设置图片全部白底
    setAllWhite() {
      this.isAllSelect = true
      this.fenbianlvVisible = true
      this.editPictureTitle = '图片白底'
      this.fenbianlvPrctureList = this.imgListSelect.map(item => {
        return {
          isChecked: true,
          url: item
        }
      })
      this.isClickItem = false
      this.comName = 'baidi'
    },
    //设置全部分辨率
    setAllFenbianlv() {
      this.isAllSelect = true
      this.fenbianlvVisible = true
      this.buttonLoadding = false
      this.editPictureTitle = '修改分辨率'
      this.fenbianlvPrctureList = this.imgListSelect.map(item => {
        return {
          isChecked: true,
          url: item
        }
      })
      this.isClickItem = false
      this.comName = 'fenbianlv'
      this.pictureForm = {
        fenbianlType: 800,
        width: 800,
        height: 800
      }
    },
    changeAllSelect(val) {
      this.fenbianlvPrctureList.forEach(item => {
        item.isChecked = val
      })
    },
    changeFenbianType(val) {
      if (val == 4) {
        this.pictureForm.width = ''
        this.pictureForm.height = ''
        return
      }
      this.pictureForm.width = val
      this.pictureForm.height = val
    },
    clickItemChecked(item){
      item.isChecked = !item.isChecked
      //有值 未全选  -1 全选
      let noFindChecked = this.fenbianlvPrctureList.findIndex(item => !item.isChecked)
      this.isAllSelect = noFindChecked == -1 ? true:false
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .upload-demo {
  .el-upload--picture-card {
    line-height: initial;

    .el-upload-dragger {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}

.Minister-top {
  width: 99%;
  border-radius: 4px;
  overflow: hidden;

  .Ministerbackground {
    background: #d7f0dbff;
  }

  .Minister-top-top {
    width: 100%;
    height: 40px;

    .Minister-top-left {
      width: 80px;
      line-height: 40px;
      float: left;
      text-align: center;
      font-size: 16px;
      color: #fff;
    }

    .Minister-top-color {
      // color: #567801;
      background: #39b54a;
    }
  }

  .information_content {
    width: calc(100% - 22px);
    overflow: hidden;
    padding: 10px 10px;
    border: 1px solid rgba(168, 168, 168, 0.8);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: none !important;
    margin-bottom: 15px;

    .information_Mandarin {
      overflow: hidden;
      // margin-left: 4%;
      display: flex;
      justify-content: space-between;

      ul {
        max-width: 1450px;
        flex: 1;
        display: flex;

        li {
          width: 90px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          // float: left;
          cursor: pointer;
        }

        .liactive {
          background: #2c8dff;
          color: #fff;
        }
      }
    }

    .information_tips {
      line-height: 50px;
      margin-left: 10%;
      color: #f89a9a;
      font-size: 16px;
    }

    .information_input {
      overflow: hidden;
      position: relative;

      .region {
        width: 80px;
        height: 80px;
        background: rgba(0, 0, 0, 0);
        // background: red;
        position: absolute;
        left: 0px;
        top: 50px;
      }

      .information_Title {
        width: 8%;
        overflow: hidden;
        color: #7d7171;
        text-align: right;
        float: left;
        line-height: 33px;
        margin-right: 1%;
        font-weight: bold;
        user-select: none;

        .tips {
          color: red;
        }
      }

      .input_el {
        width: 88%;
        float: left;

        .Preservation {
          float: right;
          padding: 10px 10px;
          background: #73ade9;
          color: #fff;
          margin-top: 5px;
          border-radius: 5px;
        }
      }
    }
  }
}

.uploadPictures {
  /deep/ .el-upload-list__item {
    width: 178px;
    height: 178px;
  }

  /deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
    line-height: 178px;
    padding: 0 20px;
  }

  /deep/ .selectUpload {
    // .el-upload.el-upload--picture-card,
    .el-upload-list__item-status-label {
      display: none;
    }
  }

  /deep/ .el-dialog__body {
    word-break: break-word;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;

    .list-group-item {
      width: 178px;
      height: 178px;
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
      // float: left;
      position: relative;
      overflow: hidden;

      .mask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition-duration: 0.5s;

        .custom-icon {
          font-size: 20px;
          margin: 0 8px;
          color: #fff;
        }
      }

      &:hover .mask {
        opacity: 1;
        border-color: #409eff;
      }
    }

    .list-group-item img {
      width: 100%;
      height: 100%;
    }
  }

  .showImg {
    width: 148px;
    float: left;
    margin-right: 15px;
  }

  .avatar-uploader {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
    line-height: 178px;
    font-size: 40px;

    &:hover {
      border-color: #409eff;
    }
  }
}

.productimgs {
  width: calc(100% - 22px);
  overflow: hidden;
  padding: 10px 10px;
  border: 1px solid rgba(168, 168, 168, 0.8);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top: none !important;
  margin-bottom: 15px;
}

.prduct_img {
  height: 130px;
  width: 130px;
  margin: 0 10px 10px 0;
}

.select-img {
  width: 100%;
  height: 320px;
  overflow: auto;

  .option {
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    float: left;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;

    .img-mask {
      position: absolute;
      right: -17px;
      top: -7px;
      width: 46px;
      height: 26px;
      background: #13ce66;
      text-align: center;
      transform: rotate(45deg);

      .el-true-check {
        color: #fff;
        font-size: 12px;
        margin-top: 12px;
        transform: rotate(-45deg);
      }
    }

    img {
      width: 146px;
    }
  }
}

.custom-update {
  /deep/ .el-upload--picture-card {
    background: initial;
    border: initial;
    width: initial;
    height: initial;
    line-height: initial;
  }
}
</style>
